<template>
	<transition
			name="custom-classes-transition"
			:enter-active-class="$_mnLst_styleComponentAnimation()">
		<template v-if="$_mnLst_stateComponentIsInitialized">
			<v-list	class="customVList" 
					expand
					:color="$_mnLst_styleListColor"
					:dark="$_mnLst_styleListDark"
					:dense="$_mnLst_styleListDense"
					:elevation="$_mnLst_styleListElevation"
					:flat="$_mnLst_styleListFlat"
					:light="$_mnLst_styleListLight"
					:nav="$_mnLst_styleListNav"
					:rounded="$_mnLst_styleListRounded"
					:shaped="$_mnLst_styleListShaped"
					:subheader="$_mnLst_styleListSubheader"
					:three-line="$_mnLst_styleListThreeLine"
					:tile="$_mnLst_styleListTile"
					:two-line="$_mnLst_styleListTwoLine">
				<v-list-group
						v-model="isOpened_"
						no-action>
					<template v-slot:activator>
						<v-row no-gutters>
							<v-col>
								<v-subheader>
									<span	class="caption"
											v-html="$_mnLst_langTitle" />
								</v-subheader>
							</v-col>
						</v-row>
					</template>
					<template v-for="(menuItemVals, menuItemKey) in sortObject($_mnLst_appMenuItemsContentsIsMobileMenu, 'order')">
						<template v-if="menuItemVals.isMobileMenu">
							<template v-if="checkMenuGroup(menuItemVals.menuGroup) && checkSecurityGroup(menuItemVals.securityGroup)">
								<v-list-item
										:key="menuItemKey"
										class="customVListItem" 
										dense
										@click="openLink(menuItemVals.link)">
									<v-list-item-icon>
										<template v-if="menuItemVals.icon">
											<v-icon v-text="menuItemVals.icon" />
										</template>
										<template v-else>
											<v-icon>launch</v-icon>
										</template>
									</v-list-item-icon>
									<v-list-item-title>
										<span	class="caption"
												v-html="$_mnLst_langAppMenuTitle(menuItemVals)" />
									</v-list-item-title>
									<template v-if="debugMode">
										<debugger-order-alert :order="menuItemVals.order" />
									</template>
								</v-list-item>
							</template>
						</template>
					</template>
					<template v-if="$_mnLst_currentUser">
						<v-list-item
								class="customVListItem" 
								dense
								@click="$_mnLst_logout()">
							<v-list-item-icon>
								<v-icon>panorama_fish_eye</v-icon>
							</v-list-item-icon>
							<v-list-item-title>
								<span	class="caption"
										v-html="$_mnLst_langLogoutButtonTitle" />
							</v-list-item-title>
						</v-list-item>
					</template>
					<template v-else>
						<v-list-item
								class="customVListItem" 
								dense
								@click="openLink({ to: '/login' })">
							<v-list-item-icon>
								<v-icon>account_circle</v-icon>
							</v-list-item-icon>
							<v-list-item-title>
								<span	class="caption"
										v-html="$_mnLst_langLoginButtonTitle" />
							</v-list-item-title>
						</v-list-item>
					</template>
				</v-list-group>
			</v-list>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'MenuList',
		data() {
			return {
				componentName_: 'menuList',

				isOpened_: true
			}
		},
		computed: {
			// current user
			$_mnLst_currentUser() {
				const self_ = this;
				return self_.getCurrentUser()
			},
			// state 
			$_mnLst_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			// app menu items 
			$_mnLst_appMenuItemsContents() {
				const self_ = this;

				const contents_ = self_.getAppContents('menuItems')
				return self_.getContentsSubset(contents_, 'isDummy', false)
			},
			$_mnLst_appMenuItemsInits() {
				const self_ = this;
				return self_.getAppInits('menuItems')
			},
			$_mnLst_appMenuItemsContentsIsMobileMenu() {
				const self_ = this;
				const menuItems_ = self_.$_mnLst_appMenuItemsContents;
				if(self_.isEmpty(menuItems_)) { return null }
				return self_.getContentsSubset(menuItems_, 'isMobileMenu', true)
			},
			$_mnLst_langAppMenuTitle() {
				const self_ = this;
				return menuItemVals => {
					return self_.getLangsVal(menuItemVals.title)
				}
			},
			// contents / inits
			$_mnLst_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_mnLst_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// lang
			$_mnLst_langTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mnLst_inits(), 'title')
				return self_.getLangsVal(lang_)
			},
			$_mnLst_langLoginButtonTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mnLst_inits(), 'loginButtonTitle')
				return self_.getLangsVal(lang_)
			},
			$_mnLst_langLogoutButtonTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mnLst_inits(), 'logoutButtonTitle')
				return self_.getLangsVal(lang_)
			},
			// style
			$_mnLst_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_mnLst_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_mnLst_inits(), 'component')
				}
			},
			$_mnLst_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_mnLst_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_mnLst_styleList() {
				const self_ = this;
				if(self_.isEmpty(self_.$_mnLst_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_mnLst_inits(), 'list')
			},
			$_mnLst_styleListColor() {
				const self_ = this;
				const list_ = self_.$_mnLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.color)
			},
			$_mnLst_styleListDark() {
				const self_ = this;
				const list_ = self_.$_mnLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.dark)
			},
			$_mnLst_styleListDense() {
				const self_ = this;
				const list_ = self_.$_mnLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.dense)
			},
			$_mnLst_styleListElevation() {
				const self_ = this;
				const list_ = self_.$_mnLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.elevation)
			},
			$_mnLst_styleListFlat() {
				const self_ = this;
				const list_ = self_.$_mnLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.flat)
			},
			$_mnLst_styleListLight() {
				const self_ = this;
				const list_ = self_.$_mnLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.light)
			},
			$_mnLst_styleListNav() {
				const self_ = this;
				const list_ = self_.$_mnLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.nav)
			},
			$_mnLst_styleListRounded() {
				const self_ = this;
				const list_ = self_.$_mnLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.rounded)
			},
			$_mnLst_styleListShaped() {
				const self_ = this;
				const list_ = self_.$_mnLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.shaped)
			},
			$_mnLst_styleListSubheader() {
				const self_ = this;
				const list_ = self_.$_mnLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.subheader)
			},
			$_mnLst_styleListThreeLine() {
				const self_ = this;
				const list_ = self_.$_mnLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.threeLine)
			},
			$_mnLst_styleListTile() {
				const self_ = this;
				const list_ = self_.$_mnLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.tile)
			},
			$_mnLst_styleListTwoLine() {
				const self_ = this;
				const list_ = self_.$_mnLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.twoLine)
			}
		},
		methods: {
			$_mnLst_logout() {
				const self_ = this;
				const router_ = self_.$router;

				Promise.resolve().then(() => {
					return self_.logout()
				}).then(() => {
					router_.push('/')
				})
			}
		}
	}
</script>

<style scoped>
</style>